import { render, staticRenderFns } from "./BlendList.vue?vue&type=template&id=4d710cf2&scoped=true"
import script from "./BlendList.vue?vue&type=script&lang=js"
export * from "./BlendList.vue?vue&type=script&lang=js"
import style0 from "./BlendList.vue?vue&type=style&index=0&id=4d710cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d710cf2",
  null
  
)

export default component.exports